/**
 * Returns true when `value` is a finite non-negative number.
 */
export const isFiniteNonNegativeNumber = ( value: unknown ): value is number => {
    return typeof value === "number" && Number.isFinite( value ) && value >= 0;
};
